const getPhoneType = (): string => {
  const ua = navigator.userAgent.toString().toLowerCase(),
    iphone = /iphone/gi,
    ipad = /ipad/gi,
    android = /android/gi;
  if (iphone.test(ua)) {
    return 'iphone';
  } else if (ipad.test(ua)) {
    return 'ipad';
  } else if (android.test(ua)) {
    return 'android';
  } else {
    return 'other';
  }
};

export default getPhoneType;
